import { assertString } from '@/libs/utils'
import { defineRule } from '../define-rule'
import { now } from '@/utils/date-util'
import { toDate } from '@/libs/utils/parser.util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type DateNotInFutureRuleConstructorParams = BaseRuleConstructorParams<{
  dateFormat?: string
}>

export const dateNotInFuture = defineRule(
  'date_not_in_future',
  ({ config = {}, errorMessage }: DateNotInFutureRuleConstructorParams) => {
    const { dateFormat = 'DD.MM.YYYY' } = config
    const error = errorMessage ?? false
    return (value: string) => {
      try {
        assertString(value)
        const day = toDate(value, dateFormat)
        // Found no other solution to add the isSameOrBefore plugin in typescript rule check
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (day as any).isSameOrBefore(toDate(now().format(dateFormat), dateFormat)) || error
      } catch (e) {
        console.error('Error while execute dateNotInFuture validation rule', e)
        return error
      }
    }
  }
)
